import { defineAttrs as e } from "../../utils/typed-attrs.js";
import { centerable as t } from "../decorators/centerable.js";
import { stylable as n } from "../decorators/stylable.js";
import "../decorators.js";
import { generateHeadingId as r } from "../../helpers/id-generator.js";
var i = n(t({
	content: "inline*",
	attrs: e({
		type: { default: "heading" },
		idAttribute: { default: "" }
	}),
	defining: !0,
	group: "block",
	parseDOM: [{
		tag: "h1",
		getAttrs() {
			return { idAttribute: r() };
		}
	}, {
		tag: "p[role=heading][aria-level=\"1\"]",
		priority: 60,
		getAttrs() {
			return { idAttribute: r() };
		}
	}],
	toDOM(e) {
		return [
			"h1",
			{ id: e.attrs.idAttribute },
			0
		];
	}
})), a = n(t({
	content: "inline*",
	attrs: e({
		type: { default: "subheading" },
		idAttribute: { default: "" }
	}),
	defining: !0,
	group: "block",
	parseDOM: [
		{
			tag: "h2",
			getAttrs() {
				return { idAttribute: r() };
			}
		},
		{
			tag: "p[role=heading][aria-level=\"2\"]",
			priority: 60,
			getAttrs() {
				return { idAttribute: r() };
			}
		},
		{
			tag: "h3",
			getAttrs() {
				return { idAttribute: r() };
			}
		},
		{
			tag: "p[role=heading][aria-level=\"3\"]",
			priority: 60,
			getAttrs() {
				return { idAttribute: r() };
			}
		},
		{
			tag: "h4",
			getAttrs() {
				return { idAttribute: r() };
			}
		},
		{
			tag: "p[role=heading][aria-level=\"4\"]",
			priority: 60,
			getAttrs() {
				return { idAttribute: r() };
			}
		}
	],
	toDOM(e) {
		return [
			"h2",
			{ id: e.attrs.idAttribute },
			0
		];
	}
})), o = n(t({
	content: "inline*",
	attrs: e({
		type: { default: "subheading3" },
		idAttribute: { default: "" }
	}),
	defining: !0,
	group: "block",
	parseDOM: [],
	toDOM(e) {
		return [
			"h3",
			{ id: e.attrs.idAttribute },
			0
		];
	}
})), s = n(t({
	content: "inline*",
	attrs: e({
		type: { default: "subheading4" },
		idAttribute: { default: "" }
	}),
	defining: !0,
	group: "block",
	parseDOM: [],
	toDOM(e) {
		return [
			"h4",
			{ id: e.attrs.idAttribute },
			0
		];
	}
}));
//#endregion
export { i as headingSpec, o as subheading3Spec, s as subheading4Spec, a as subheadingSpec };
